import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular';
import { LoginFormModule } from 'app/logon/login-form/login-form.module';
import { TooltipService } from 'app/services/tooltip-service/tooltip.service';

import { ISPUITooltipModule } from '@ispui/ng-tooltip';

import { SvgSpriteModule } from 'common/svg-icon/svg-sprite/svg-sprite.module';

import { AppComponent } from './app.component';
import { AppService } from './app.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    SvgSpriteModule.forRoot({
      asyncSprite: () =>
        import('assets/icons/icons-sprite').then(m => m.SPRITE),
    }),
    ISPUITooltipModule,
    LoginFormModule,
  ],
  providers: [
    AppService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private readonly tooltipService: TooltipService) {
    this.tooltipService.watchForElement('body');
  }
}
